import styled from "styled-components";

export const RegisterContainerStyled = styled.div`
  .input_regis_type_wrap {
    margin-bottom: 42px;
  }
`;
